export default __webpack_public_path__ + "static/media/Inventory-sub-tier-green.c82d0420.svg";